import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import FormService from '../../../core/services/FormService';
import NotificationService from '../../../core/services/NotificationService';
import { isRequired } from '../../../core/validations';

export default class CanDosFormService {
  fetch = new FetchService();
  submit = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this, {
      courseId: null,
      onSuccess: null,
    });
    this.form.validations = {
      title: [isRequired],
      locale: [isRequired],
      description: [isRequired],
    };
  }

  handleLoad = action((courseId, onSuccess) => {
    this.form.reset();
    this.form.setInitialValues({});

    this.courseId = courseId;
    this.onSuccess = onSuccess;
  });

  handleSubmit = action(() => {
    this.form.submitted = true;
    if (this.form.errors) {
      NotificationService.addNotification('Fill the required fields', 'error');
      return;
    }

    const itemId = this.form.getValue('id');
    this.submit
      .fetch({
        method: itemId ? 'put' : 'post',
        url: itemId ? `/courses/${this.courseId}/can-dos/${itemId}` : `/courses/${this.courseId}/can-dos`,
        body: this.form.getValues(),
        apiVersion: 'V2',
      })
      .then(() => {
        if (this.submit.data) {
          this.form.reset();
          if (this.onSuccess) {
            this.onSuccess();
          }
          NotificationService.addNotification(`Can Do ${itemId ? 'updated' : 'created'} successfully.`, 'success');
        }
        if (this.submit.error) {
          NotificationService.addNotification(`Error ${itemId ? 'updating' : 'creating'} can do.`, 'error');
        }
      });
  });
}
